//#region lib/utils/numbers.ts
function e(e, { locale: t = "en-US", maximumFractionDigits: n = 1, minimumFractionDigits: r = 0 } = {}) {
	let i = Number.isFinite(e) ? e : 0;
	return `${new Intl.NumberFormat(t, {
		maximumFractionDigits: n,
		minimumFractionDigits: r
	}).format(i)}%`;
}
//#endregion
export { e as formatPercentage };
